<ng-template #content let-modal>
  <form (ngSubmit)="assignToCustomerSupport()" class="lty-form">
    <div class="modal-body">
      <div class="modal-title mb-16" i18n>
        Attribuer à un chargé de clientèle
      </div>
      <div class="form-group">
        <label i18n>Chargé de clientèle</label>
        <mat-form-field class="lty-input">
          <mat-select [(value)]="customerSupportId">
            <mat-option
              *ngFor="let option of customerSupportList"
              [value]="option.adminId"
              >{{ option.firstName }} {{ option.lastName }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="d-flex justify-content-end w-100">
        <button
          type="button"
          class="lty-btn lty-btn-white"
          (click)="modal.close('Close click')"
          i18n
        >
          Annuler
        </button>
        <button
          type="submit"
          [disabled]="!canSubmit() || submitted"
          class="lty-btn lty-btn-primary ms-2"
          i18n
        >
          Attribuer
        </button>
      </div>
    </div>
  </form>
</ng-template>
